module.exports = __webpack_public_path__ + "img/386-b1646b.png";